<template>
  <div @click="to()" :class="link ? 'pointer' : ''">
    <div class="card-info shadow-sm px-2 align-items-center bg-white">
      <div class="text-center" v-if="icon" style="padding: 0 14px 0 7px">
        <icon :name="icon" size="28" class="text-primary"/>
      </div>
      <div class="text-muted">
        <div class="font-weight-bold text-primary limite" v-html="title"></div>
        <slot></slot>
      </div>
      <div class="align-self-center text-primary text-center" style="width: 40px; margin-left: auto" v-if="link || iconPos">
        <i :class="['fa-solid', iconPos ? iconPos : 'fa-circle-info']"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from "./Icon";
  export default {
    components: {Icon},
    props: ['title', 'link', 'action', 'icon', 'icon-pos'],
    name: "CardInfo",
    methods: {
      to() {
        if (this.link) {
          this.$router.push(this.link)
        } else {
          this.$emit('action')
        }
      }
    }
  }
</script>

<style scoped>
  .card-info {
    padding: 14px 6px;
    color: var(--text-theme);
    border-radius: 16px;
    display: flex;
    border: 1px solid var(--border-color);
    background-color: var(--bg-theme-secondary);
  }
  .small {
    line-height: 15px;
  }
  .limite {
    max-height: 26px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
</style>
